import { useMemo } from 'react';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getSelectedStatus, getTimeOffs } from '../../../../store/schedules/selectors';
import { STATUS_FILTER_MAP } from '../data/timeoff';

export function useTimeoffFilter() {
  const timeOffs = useAppSelector(getTimeOffs);
  const selectedStatus = useAppSelector(getSelectedStatus);

  const getTimeoffsByFilters = useMemo(() => {
    let filteredTimeoffs = timeOffs;

    if (selectedStatus > 0) {
      filteredTimeoffs = filteredTimeoffs.filter((timeoff) => timeoff.status === STATUS_FILTER_MAP[selectedStatus]);
    }

    return filteredTimeoffs;
  }, [timeOffs, selectedStatus]);

  return {
    getTimeoffsByFilters,
  };
}
